module.exports = __webpack_public_path__ + "static/media/productMaster.92168abe.svg";